// Global Instructions Rule Applied!

import type { KanbanColumn } from '../../interfaces.ts'

/** Default light gray when pipeline_configs has no colour */
const DEFAULT_COLUMN_COLOUR = '#9CA3AF'

/**
 * Get column color from pipeline config or default to light gray
 * Uses colour from pipeline_configs when present, otherwise light gray
 */
export function getColumnColour(column: KanbanColumn): string {
  const colour = column.colour as string | undefined
  if (colour && typeof colour === 'string' && colour.trim()) {
    return colour.trim()
  }
  return DEFAULT_COLUMN_COLOUR
}
